import { LineController } from 'chart.js';

export class LineWithLineController extends LineController {
    static override id = 'lineWithLine';
    static override defaults = LineController.defaults;

    override draw() {
        // Call parent's draw method
        super.draw();

        // Get the chart instance
        const chart = this.chart as any;

        // Check if tooltip has active points
        if (!chart.tooltip?._active?.length) return;

        const activePoint = chart.tooltip._active[0];
        const ctx = chart.ctx;
        const x = activePoint.element.x;

        // In v3, scales are accessed by ID (no array index)
        const yScale = chart.scales.y;
        if (!yScale) return;

        const topY = yScale.top;
        const bottomY = yScale.bottom;

        // Draw vertical line
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(x, topY);
        ctx.lineTo(x, bottomY);
        ctx.lineWidth = 2;
        ctx.strokeStyle = '#07C';
        ctx.stroke();
        ctx.restore();
    }
}
